/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-49
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_75 from /* 75 */"./75"
import * as /* [auto-meaningful-name] */Module_262 from /* 262 */"./262"
var bf = [
  {
    type: "WidgetTitle",
    hasDisableOrVisible: true
  }, [
    {
      type: "VisibleSwitch"
    }, {
      type: "DisabledSwitch"
    }
  ], {
    type: "TextInput",
    label: "url",
    key: "url",
    clearButtonVisible: true
  }, {
    type: "WidgetOpacity"
  }, {
    type: "Size",
    sizeRange: [[Module_262.c, Module_75.e], [Module_262.b, Module_75.d]]
  }, {
    type: "Coordinate"
  }
]
export { bf }
